"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var BenchmarkBar_1 = __importDefault(require("atomicComponents/organisms/BarGraphs/BenchmarkBar"));
var ReportContext_1 = __importDefault(require("../ReportContext"));
var QuoteBenchmarkBar = function (_a) {
    var _b = _a.item, listPrice = _b.listPrice, benchmarks = _b.benchmarks, vendorQuote = _b.vendorQuote;
    var type = (0, react_1.useContext)(ReportContext_1.default).type;
    if (!(benchmarks && listPrice)) {
        return null;
    }
    var min = type === 'percent' ? benchmarks.min : (1 - benchmarks.max) * listPrice;
    var max = type === 'percent' ? benchmarks.max : (1 - benchmarks.min) * listPrice;
    var median = type === 'percent' ? benchmarks.median : (1 - benchmarks.median) * listPrice;
    var mark = vendorQuote && (type === 'percent' ? (listPrice - vendorQuote) / listPrice : vendorQuote);
    return ((0, jsx_runtime_1.jsx)(BenchmarkBar_1.default, { min: min, max: max, median: median, mark: mark, type: type }));
};
exports.default = QuoteBenchmarkBar;
